import {combineReducers} from 'redux'
import connectionReducer from './connection'
import themeToggler from './themeToggler'
import tokenReducer from './token'
import userReducer from './user'
import transacReducer from './transaction'


const allReducers = combineReducers({
    connection:connectionReducer,
    theme:themeToggler,
    user:userReducer,
    token:tokenReducer,
    transac:transacReducer
})

export default allReducers